import { NavItem as _NavItem, NavItemProps as _NavItemProps } from "reactstrap";

    export const NavItem = _NavItem;
    export type NavItemProps = _NavItemProps;
    